import Component from '@glimmer/component';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { useStyles } from '@frontile/theme';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';
import { a as decorateMethodV2 } from '../../runtime-BPCpkOf1-DV8zmEr2.js';

class FormFieldInput extends Component {
  get type() {
    if (typeof this.args.type === 'string') {
      return this.args.type;
    }
    return 'text';
  }
  handleOnInput(event) {
    if (typeof this.args.onInput === 'function') {
      this.args.onInput(event.target.value, event);
    }
  }
  static {
    decorateMethodV2(this.prototype, "handleOnInput", [action]);
  }
  handleOnChange(event) {
    if (typeof this.args.onChange === 'function') {
      this.args.onChange(event.target.value, event);
    }
  }
  static {
    decorateMethodV2(this.prototype, "handleOnChange", [action]);
  }
  get classes() {
    const {
      input
    } = useStyles();
    return input({
      size: this.args.size
    }).input({
      class: this.args.class
    });
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <input {{on \"input\" this.handleOnInput}} {{on \"change\" this.handleOnChange}} id={{@id}} value={{@value}} type={{this.type}} class={{this.classes}} data-test-id=\"form-field-input\" ...attributes />\n  ", {
      strictMode: true,
      scope: () => ({
        on
      })
    }), this);
  }
}

export { FormFieldInput as default };
//# sourceMappingURL=input.js.map
